export default __webpack_public_path__ + "6bc0a10c06b8187a9cb227cf4c8c159b.svg";